// extracted by mini-css-extract-plugin
export default {"contactBtn":"ContactBtn_contactBtn__DCaEc","text":"ContactBtn_text__DyHlc","icon":"ContactBtn_icon__bANgs"};